/**
 * @generated SignedSource<<b008d377e275df49f432ee3afdf27f79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WeeklyPaceSkillSource = "DEMONSTRATED" | "DIRECTLY_PASSED" | "%future added value";
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGoalMetPassedOrNotQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
  returnMeetOrPassedSkillGoal: boolean;
  source: WeeklyPaceSkillSource;
};
export type DashboardGoalMetPassedOrNotQuery$data = {
  readonly studentSkillGoalsReport: ReadonlyArray<{
    readonly firstName: string | null | undefined;
    readonly lastName: string | null | undefined;
    readonly publicUserId: string | null | undefined;
  }>;
};
export type DashboardGoalMetPassedOrNotQuery = {
  response: DashboardGoalMetPassedOrNotQuery$data;
  variables: DashboardGoalMetPassedOrNotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "returnMeetOrPassedSkillGoal"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "source"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "returnMeetOrPassedSkillGoal",
    "variableName": "returnMeetOrPassedSkillGoal"
  },
  {
    "kind": "Variable",
    "name": "source",
    "variableName": "source"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGoalMetPassedOrNotQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "studentSkillGoalsReport",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGoalMetPassedOrNotQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "studentSkillGoalsReport",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca25a8e0149667f0b1c6bb12fdda28d7",
    "id": null,
    "metadata": {},
    "name": "DashboardGoalMetPassedOrNotQuery",
    "operationKind": "query",
    "text": "query DashboardGoalMetPassedOrNotQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n  $returnMeetOrPassedSkillGoal: Boolean!\n  $source: WeeklyPaceSkillSource!\n) {\n  studentSkillGoalsReport(filter: $filter, returnMeetOrPassedSkillGoal: $returnMeetOrPassedSkillGoal, source: $source) {\n    firstName\n    lastName\n    publicUserId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ccb0e2e9105ecf6886f06792ee3e77d";

export default node;
